window.addEventListener("DOMContentLoaded", function () {
  // banner 按钮点击跳转
  $(".valentine-2026-banner .valentine-2026-banner-button").on("click", function () {
    const offsetTop = $(".valentine-2026-discount").offset().top;
    const gap = 200;

    $("html, body").animate({ scrollTop: offsetTop - gap }, 400);
  });

  // discount 按钮点击跳转
  $(".valentine-2026-discount .valentine-2026-discount-button-1").on("click", function () {
    const offsetTop = $(".valentine-2026-top-pick").offset().top;
    const gap = 80;

    $("html, body").animate({ scrollTop: offsetTop - gap }, 400);
  });

  $(".valentine-2026-discount .valentine-2026-discount-button-2").on("click", function () {
    const host = document.querySelector(".loloyal-launcher-box");
    if (host && host.shadowRoot) {
      const button = host.shadowRoot.querySelector(".loloyal-launcher");
      button && button.click();
    }
  });

  // 礼品卡模块，点击按钮下载模版

  $(".valentine-2026-gift-card .pc-layout .item-cell-1 .item-2 .valentine-2026-gift-card-button,.valentine-2026-gift-card .m-layout .item-cell-2 .item-2 .valentine-2026-gift-card-button").on("click", function () {
    const file = "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/Valentine_s_Day_card.zip?v=1769757441 ";

    window.location.href = file;
  });

  // 扫地机器人品类 变体图片改为颜色
  const productImage = {
    "x60-max-ultra-complete-robot-vacuum": {
      White:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-x60-max-ultra-complete-white.webp?v=1769507567",
      Black:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-x60-max-ultra-complete.webp?v=1769507567",
    },
    "aqua10-ultra-roller-robot-vacuum": {
      White:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-aqua10-ultra-roller.webp?v=1769507567",
      Black:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-aqua10-ultra-roller-black.webp?v=1769507567",
    },
    "l40-ultra-gen2-robot-vacuum": {
      White:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-l40-ultra-gen2-white.webp?v=1769743793",
      Black:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-l40-ultra-gen2.webp?v=1769743793",
    },
    "l50-ultra-robot-vacuum": {
      White:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-l50-ultra.webp?v=1769507567",
      Black:
        "https://cdn.shopify.com/s/files/1/0729/1997/4145/files/valentine-2026-robot-vacuum-l50-ultra-black.webp?v=1769743793",
    },
  };
  $(".valentine-2026-robot-vacuum .product-variant-img").each(function () {
    const $el = $(this);
    const color = $el.data("swatch-color")?.toLocaleLowerCase();
    if (color) {
      const value =
        color === "white"
          ? "linear-gradient(180deg, #D9D9D9 0%, #FFF 100%)"
          : color === "black"
          ? "linear-gradient(180deg, #000 0%, #6E6E6E 100%)"
          : "";
      this.style.setProperty("--valentine-variant-color", value);
    }

    $el.on("click", function () {
      const available = $el.data("available");
      $el
        .closest(".content")
        .find(".quick-buynow-btn")
        .text(available ? "Buy Now" : "Sold Out");

      const product = $el.data("product");
      const title = $el.data("variant-title");
      if (productImage[product][title]) {
        $el.closest(".all_info").find(".image img").removeAttr("srcset").attr("src", productImage[product][title]);
      }
    });
  });

  // 泳池机器人品类，按钮全部跳转到外站
  // setTimeout(() => {
  //   $(".valentine-2026-pool-cleaner .all_info multi-add-cart-button").each(function () {
  //   this.addEventListener(
  //     "click",
  //     function (e) {
  //       e.stopImmediatePropagation();
  //       e.preventDefault();

  //       const $link = $(this).closest(".product-link-box").find(".learn_more_btn a").first();

  //       $link[0]?.click();
  //     },
  //     true
  //   );
  // });
  // }, 3000)

  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type == "submit") {
      $(".valentine-2026-sub-form.before-submit").removeClass("before-submit");
    }
  });

  $("#upCart").on("click", ".upcart-header-close-button, .upcart-backdrop", function (e) {
    if (window.timber?.RightDrawer?.drawerIsOpen) {
      window.timber.RightDrawer.drawerIsOpen = false;
    }
  });
});
